import { CALL_API } from '../middleware/ApiMiddleware';

export const CHARGE_CODES_FETCH_REQUEST = 'CHARGE_CODES_FETCH_REQUEST';
export const CHARGE_CODES_FETCH_SUCCESS = 'CHARGE_CODES_FETCH_SUCCESS';
export const CHARGE_CODES_FETCH_FAILURE = 'CHARGE_CODES_FETCH_FAILURE';

export const CHARGE_CODE_FETCH_REQUEST = 'CHARGE_CODE_FETCH_REQUEST';
export const CHARGE_CODE_FETCH_SUCCESS = 'CHARGE_CODE_FETCH_SUCCESS';
export const CHARGE_CODE_FETCH_FAILURE = 'CHARGE_CODE_FETCH_FAILURE';

export const CHARGE_CODE_CREATE_REQUEST = 'CHARGE_CODE_CREATE_REQUEST';
export const CHARGE_CODE_CREATE_SUCCESS = 'CHARGE_CODE_CREATE_SUCCESS';
export const CHARGE_CODE_CREATE_FAILURE = 'CHARGE_CODE_CREATE_FAILURE';

export const CHARGE_CODE_EDIT_REQUEST = 'CHARGE_CODE_EDIT_REQUEST';
export const CHARGE_CODE_EDIT_SUCCESS = 'CHARGE_CODE_EDIT_SUCCESS';
export const CHARGE_CODE_EDIT_FAILURE = 'CHARGE_CODE_EDIT_FAILURE';

export const CHARGE_CODE_DELETE_REQUEST = 'CHARGE_CODE_DELETE_REQUEST';
export const CHARGE_CODE_DELETE_SUCCESS = 'CHARGE_CODE_DELETE_SUCCESS';
export const CHARGE_CODE_DELETE_FAILURE = 'CHARGE_CODE_DELETE_FAILURE';

const baseURL = 'xerce/config/charge-codes';

export const fetchChargeCodes = (params?: IChargeCodeListingParams, hideLoading?: boolean) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [CHARGE_CODES_FETCH_REQUEST, CHARGE_CODES_FETCH_SUCCESS, CHARGE_CODES_FETCH_FAILURE],
    hideLoadingWidget: hideLoading,
  },
});

export const fetchChargeCode = (chargeCodeId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${chargeCodeId}`,
    method: 'get',
    authenticated: true,
    types: [CHARGE_CODE_FETCH_REQUEST, CHARGE_CODE_FETCH_SUCCESS, CHARGE_CODE_FETCH_FAILURE],
  },
});

export const createChargeCode = (chargeCode: IChargeCodeRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    authenticated: true,
    body: chargeCode,
    types: [CHARGE_CODE_CREATE_REQUEST, CHARGE_CODE_CREATE_SUCCESS, CHARGE_CODE_CREATE_FAILURE],
  },
});

export const editChargeCode = (chargeCodeId: number, chargeCode: IChargeCodeRequest, hideLoading?: boolean) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${chargeCodeId}`,
    method: 'put',
    authenticated: true,
    body: chargeCode,
    types: [CHARGE_CODE_EDIT_REQUEST, CHARGE_CODE_EDIT_SUCCESS, CHARGE_CODE_EDIT_FAILURE],
    hideLoadingWidget: hideLoading,
  },
});

export const deleteChargeCode = (chargeCodeId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${chargeCodeId}`,
    method: 'delete',
    authenticated: true,
    types: [CHARGE_CODE_DELETE_REQUEST, CHARGE_CODE_DELETE_SUCCESS, CHARGE_CODE_DELETE_FAILURE],
  },
});
